import {
  SkeletonBadge,
  SkeletonSurfaceHeader,
  SkeletonTileSurface,
} from "@-/dev.improve.haniverse.components.ui.skeleton";
import { BrowseFloatingToolbarSkeletonPage } from "#browse-floating-toolbar-skeleton-page";

/** The default frequency view: "Top X%" buckets with a word-count badge over eight-column rows. */
export function BrowseWordsSkeleton() {
  return (
    <BrowseFloatingToolbarSkeletonPage
      accessibilityLabel="Loading words"
      testID="browse-words-skeleton"
    >
      {[0, 1, 2].map((key) => (
        <SkeletonTileSurface
          header={<SkeletonSurfaceHeader className="h-14.5 py-0" trailing={<SkeletonBadge />} />}
          key={key}
          rows={3}
        />
      ))}
    </BrowseFloatingToolbarSkeletonPage>
  );
}
